module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', [(_vm.isLoading) ? _c('CustomLoader', {
    attrs: {
      "width": 70
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('b-card', {
    staticClass: "mainCardBG"
  }, [_c('b-card-text', [_c('b-navbar', {
    staticClass: "formCard",
    staticStyle: {
      "border-radius": "5px !important",
      "padding-left": "0px"
    },
    attrs: {
      "toggleable": "lg",
      "type": "dark",
      "variant": "primary"
    }
  }, [_c('b-navbar-brand', {
    attrs: {
      "center": ""
    }
  }, [_vm._v("Freight Export Details New")])], 1), _vm._v(" "), _c('div', {
    staticClass: "mt-2"
  }, [_c('h5', {
    staticClass: "text-muted pull-right mt-2 ml-3"
  }, [(_vm.isLoading == false) ? _c('small', [_vm._v(_vm._s(_vm.totalRows) + " Entries")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "cod-md-12"
  }, [_c('div', {
    staticClass: "col-md-8"
  }, [_c('b-form-group', [_c('b-input-group', [_c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "placeholder": "Type To Search  (Assignment No. / Client / Container No./SB No. Shipper Inv No.)"
    },
    on: {
      "input": _vm.debounceSearch
    },
    model: {
      value: (_vm.filter),
      callback: function($$v) {
        _vm.filter = $$v
      },
      expression: "filter"
    }
  }), _vm._v(" "), _c('b-input-group-append', [_c('b-button', {
    attrs: {
      "disabled": !_vm.filter
    },
    on: {
      "click": _vm.filterClear
    }
  }, [_vm._v("Clear")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('model-list-select', {
    attrs: {
      "list": _vm.invoiceStatusList,
      "option-value": "inv",
      "option-text": "int",
      "placeholder": "Select Status"
    },
    on: {
      "input": function($event) {
        _vm.viewFFExportFCL('0', '0', '1', '1')
      }
    },
    model: {
      value: (_vm.billingFilter),
      callback: function($$v) {
        _vm.billingFilter = $$v
      },
      expression: "billingFilter"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "table-responsive tableMain"
  }, [_c('b-table', {
    attrs: {
      "show-empty": "",
      "stacked": "md",
      "items": _vm.FFExport,
      "fields": _vm.fields,
      "per-page": _vm.perPage,
      "sort-by": _vm.sortBy,
      "sort-desc": _vm.sortDesc,
      "sort-direction": _vm.sortDirection
    },
    on: {
      "update:sortBy": function($event) {
        _vm.sortBy = $event
      },
      "update:sortDesc": function($event) {
        _vm.sortDesc = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "isFFExportActive",
      fn: function(row0) {
        return [_c('span', [_vm._v(_vm._s(row0.index + 1 + (_vm.currentPage - 1) * _vm.perPage))])]
      }
    }, {
      key: "ffExportFclSeries",
      fn: function(row11) {
        return [_c('div', {
          staticClass: "text-left",
          style: (row11.item.seenExec == '0' ? 'color:red' : 'color:black')
        }, [_c('div', {
          staticClass: "showMoreData",
          style: (row11.item.seenExec == '0' ? 'color:red' : 'color:black'),
          on: {
            "click": function($event) {
              _vm.viewExportFCLPage(row11.item)
            }
          }
        }, [(row11.item.seenExec == '0') ? _c('b-badge', {
          attrs: {
            "variant": "danger"
          }
        }, [_vm._v("New\n                    "), _c('br')]) : _vm._e(), _vm._v(" "), _c('span', [_c('b', [_vm._v(" " + _vm._s(row11.item.ffExportFclSeries))])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', [_vm._v("Created on : " + _vm._s(_vm._f("moment")(row11.item.loginTime)))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', [_vm._v(" From : " + _vm._s(row11.item.EmpLoc)), _c('br')]), _vm._v(" "), _c('span', [_vm._v("By : " + _vm._s(row11.item.raisedBy))])], 1), _vm._v(" "), _c('b-button', {
          staticClass: "mt-2",
          staticStyle: {
            "font-size": "0.675rem"
          },
          attrs: {
            "size": "sm",
            "variant": "outline-info"
          },
          on: {
            "click": function($event) {
              _vm.showDocModal(row11.item)
            }
          }
        }, [_vm._v("Summary & Documents")])], 1)]
      }
    }, {
      key: "freightContainerNo",
      fn: function(row5) {
        return [(row5.item.freightContainerNo) ? _c('div', {
          staticClass: "text-left"
        }, [(row5.item.freightContainerNo) ? _c('div', _vm._l((row5.item.freightContainerNo.split(',')), function(item1, index) {
          return _c('span', {
            key: index
          }, [_c('h6', [_c('b-badge', {
            attrs: {
              "variant": "light"
            }
          }, [_vm._v(_vm._s(item1 == "" ? "-------" : item1) + "\n                      ")])], 1)])
        })) : _vm._e()]) : _c('div', {
          staticClass: "text-left"
        }, [_c('b-badge', {
          attrs: {
            "variant": "light"
          }
        }, [_vm._v("-------")])], 1)]
      }
    }, {
      key: "freightContainersType",
      fn: function(row50) {
        return [(row50.item.freightContainersType) ? _c('div', [(row50.item.freightContainersType) ? _c('div', _vm._l((row50.item.freightContainersType.split(',')), function(item2, index) {
          return _c('span', {
            key: index
          }, [_c('h6', [_c('b-badge', {
            attrs: {
              "variant": "light"
            }
          }, [_vm._v(_vm._s(item2 == "" ? "-------" : item2))])], 1)])
        })) : _vm._e()]) : _c('div', [_c('b-badge', {
          attrs: {
            "variant": "light"
          }
        }, [_vm._v("-------")])], 1)]
      }
    }, {
      key: "shippingBillNo",
      fn: function(row500) {
        return [(row500.item.shippingBillNo) ? _c('div', [(row500.item.shippingBillNo) ? _c('div', _vm._l((row500.item.shippingBillNo.split(',')), function(item2, index) {
          return _c('span', {
            key: index
          }, [_c('h6', [_c('b-badge', {
            attrs: {
              "variant": "light"
            }
          }, [_vm._v(_vm._s(item2 == "" ? "-------" : item2))])], 1)])
        })) : _vm._e()]) : _c('div', [_c('b-badge', {
          attrs: {
            "variant": "light"
          }
        }, [_vm._v("-------")])], 1)]
      }
    }, {
      key: "shipperInvNo",
      fn: function(row501) {
        return [(row501.item.shipperInvNo) ? _c('div', [(row501.item.shipperInvNo) ? _c('div', _vm._l((row501.item.shipperInvNo.split(',')), function(item2, index) {
          return _c('span', {
            key: index
          }, [_c('h6', [_c('b-badge', {
            attrs: {
              "variant": "light"
            }
          }, [_vm._v(_vm._s(item2 == "" ? "-------" : item2))])], 1)])
        })) : _vm._e()]) : _c('div', [_c('b-badge', {
          attrs: {
            "variant": "light"
          }
        }, [_vm._v("-------")])], 1)]
      }
    }, {
      key: "invoiceStatus",
      fn: function(row33) {
        return [_c('b', {
          style: (row33.item.invoiceStatus == '0' ?
            {
              color: 'green'
            } :
            {
              color: 'red'
            })
        }, [_vm._v(_vm._s(!row33.item.invoiceStatus ?
          "--" :
          row33.item.invoiceStatus == "1" ?
          "In-Progress" :
          row33.item.invoiceStatus == "0" ?
          "Sent To Accounts" :
          "--"))]), _vm._v(" "), (
          row33.item.sentForApproval &&
          row33.item.sentForApproval == '1'
        ) ? _c('b', [_c('br'), _vm._v("\n                Sent for Approval\n              ")]) : _vm._e(), _vm._v(" "), (
          row33.item.chnageApprovalStatus &&
          row33.item.chnageApprovalStatus == '1'
        ) ? _c('b', [_c('br'), _vm._v("\n                Was Sent for Approval and got Approved\n              ")]) : _vm._e(), _vm._v(" "), (
          row33.item.chnageApprovalStatus &&
          row33.item.chnageApprovalStatus == '2'
        ) ? _c('b', [_c('br'), _vm._v("\n                Was Sent for Approval and got Rejected\n              ")]) : _vm._e()]
      }
    }])
  })], 1), _vm._v(" "), _c('h5', [_c('b-row', [_c('b-col', {
    staticClass: "my-1",
    attrs: {
      "md": "12"
    }
  }, [_c('b-pagination', {
    attrs: {
      "limit": "25",
      "align": "center",
      "per-page": _vm.perPage,
      "total-rows": _vm.totalRows
    },
    on: {
      "change": function($event) {
        _vm.onPageChange($event)
      }
    },
    model: {
      value: (_vm.currentPage),
      callback: function($$v) {
        _vm.currentPage = $$v
      },
      expression: "currentPage"
    }
  })], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', [_c('b-modal', {
    ref: "doc-modal",
    staticClass: "modal-dialog-doc",
    attrs: {
      "size": "xl",
      "id": "doc",
      "no-close-on-esc": "",
      "no-close-on-backdrop": "",
      "hide-footer": "",
      "title": ""
    }
  }, [(_vm.ALLMODULE) ? _c('div', [_c('doc-form', {
    attrs: {
      "allModuleIdProp": _vm.ALLMODULE,
      "JOBSERIES": _vm.JOBSERIES
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('b-button', {
    staticClass: "mt-3",
    attrs: {
      "variant": "outline-danger",
      "block": ""
    },
    on: {
      "click": _vm.hideDocModal
    }
  }, [_vm._v("Close\n        ")])], 1)], 1), _vm._v(" "), _c('md-dialog-confirm', {
    ref: "addPop",
    attrs: {
      "md-content-html": _vm.alert.content,
      "md-ok-text": _vm.alert.ok
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6f987602","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/component/freightForwarding/newViewffExportFcl.vue
// module id = 2736
// module chunks = 0